"use client";

import { ShopProduct } from "@/lib/types";

function addToCart(product: ShopProduct) {
  const raw = localStorage.getItem("cart") || "[]";
  const cart = JSON.parse(raw) as (ShopProduct & { qty: number })[];
  const existing = cart.find((item) => item.id === product.id);
  if (existing) existing.qty += 1;
  else cart.push({ ...product, qty: 1 });
  localStorage.setItem("cart", JSON.stringify(cart));
  window.dispatchEvent(new Event("cart-updated"));
}

function productIcon(product: ShopProduct) {
  const name = product.name.toLowerCase();
  if (name.includes("пряник")) return "🥮";
  if (name.includes("серьг") || name.includes("браслет") || name.includes("коль")) return "💎";
  if (name.includes("ваза")) return "🏺";
  if (name.includes("сувенир")) return "🎁";
  return product.imagesCount ? "🖼️" : "✦";
}

export function ProductCard({ product }: { product: ShopProduct }) {
  const inStock = product.stock == null || product.stock > 0;

  return (
    <article className="group relative overflow-hidden rounded-[2rem] border border-white/70 bg-white p-4 shadow-xl shadow-orange-900/10 transition duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-orange-900/20">
      <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-amber-200 via-orange-400 to-stone-950" />
      <div className="relative mb-4 flex h-44 items-center justify-center overflow-hidden rounded-[1.5rem] bg-[radial-gradient(circle_at_30%_20%,rgba(251,191,36,.55),transparent_30%),linear-gradient(135deg,#fff7ed,#fed7aa_45%,#1c0f05)]">
        <div className="absolute right-4 top-4 rounded-full bg-white/85 px-3 py-1 text-xs font-black text-stone-700 backdrop-blur">
          {inStock ? "В наличии" : "Под заказ"}
        </div>
        <div className="absolute -bottom-10 h-24 w-48 rounded-full bg-black/20 blur-2xl" />
        <div className="relative text-7xl transition duration-500 group-hover:scale-110 group-hover:rotate-3">{productIcon(product)}</div>
      </div>

      <div className="min-h-24">
        <div className="line-clamp-1 text-xs font-black uppercase tracking-[0.18em] text-orange-700">{product.pathName || "Авторская коллекция"}</div>
        <h3 className="mt-2 line-clamp-3 text-xl font-black leading-tight tracking-[-0.03em] text-stone-950">{product.name}</h3>
        {product.article && <div className="mt-2 text-sm font-semibold text-stone-500">Арт. {product.article}</div>}
      </div>

      <div className="mt-5 flex items-end justify-between gap-3 border-t border-stone-100 pt-4">
        <div>
          <div className="text-3xl font-black tracking-[-0.05em] text-stone-950">{product.priceRub ? `${product.priceRub.toLocaleString("ru-RU")} ₽` : "по запросу"}</div>
          <div className="mt-1 text-sm font-semibold text-stone-500">{product.stock == null ? "остаток уточняется" : `остаток: ${product.stock}`}</div>
        </div>
        <a
          href="/checkout"
          onClick={() => addToCart(product)}
          className="rounded-full bg-stone-950 px-5 py-3 text-sm font-black text-white shadow-lg shadow-stone-950/20 transition hover:bg-orange-700"
        >
          В заявку →
        </a>
      </div>
    </article>
  );
}
